/* FE · Navissi para El Vestidor (oct-2026): cajones, carrito, carruseles, ficha y colección. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const FE = (window.FE = window.FE || {});

  // ---------- dinero con el formato de la tienda ----------
  FE.money = (cents) => {
    const fmt = FE.moneyFormat || '${{amount_no_decimals}}';
    const n = (cents || 0) / 100;
    const group = (x, d, th, dec) => { const [i, f] = x.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dec + f : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: group(n, 2, ',', '.'), amount_no_decimals: group(n, 0, ',', '.'),
      amount_with_comma_separator: group(n, 2, '.', ','), amount_no_decimals_with_comma_separator: group(n, 0, '.', ','),
    }[k] ?? group(n, 0, ',', '.')));
  };

  // ---------- barra de anuncios ----------
  $$('[data-fe-ann]').forEach((ann) => {
    const msgs = $$('.fe-ann__msg', ann); if (msgs.length < 2) return;
    let i = 0; const ms = (+ann.dataset.speed || 4) * 1000;
    setInterval(() => { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, ms);
  });

  // ---------- cajones ----------
  let lastFocus = null;
  FE.open = (id) => {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    $$('.fe-drawer.is-open').forEach((x) => { x.classList.remove('is-open'); x.setAttribute('aria-hidden', 'true'); });
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fe-has-drawer');
    setTimeout(() => d.querySelector('button,a,input')?.focus({ preventScroll: true }), 60);
  };
  FE.close = () => {
    $$('.fe-drawer.is-open').forEach((x) => { x.classList.remove('is-open'); x.setAttribute('aria-hidden', 'true'); });
    $$('.fe-col-main.f-open-m').forEach((m) => m.classList.remove('f-open', 'f-open-m'));
    document.body.classList.remove('fe-has-drawer');
    $$('.fe-m-sub').forEach((s) => s.classList.remove('is-on')); $('.fe-m-main')?.classList.remove('is-off');
    lastFocus?.focus?.({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-fe-open]');
    if (o) { e.preventDefault(); if (o.dataset.feOpen === 'fe-cart') FE.refreshCart().then(() => FE.open('fe-cart')); else FE.open(o.dataset.feOpen); return; }
    if (e.target.closest('[data-fe-close]')) { e.preventDefault(); FE.close(); return; }
    const sub = e.target.closest('[data-fe-sub]');
    if (sub) { document.getElementById(sub.dataset.feSub)?.classList.add('is-on'); $('.fe-m-main')?.classList.add('is-off'); return; }
    if (e.target.closest('[data-fe-back]')) { $$('.fe-m-sub').forEach((s) => s.classList.remove('is-on')); $('.fe-m-main')?.classList.remove('is-off'); }
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') FE.close(); });

  // ---------- carrito ----------
  const SECTION = 'fe-cart-drawer';
  const applyCart = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('fe-cart'), cur = document.getElementById('fe-cart');
    if (fresh && cur) { cur.innerHTML = fresh.innerHTML; for (const a of fresh.attributes) if (a.name.startsWith('data-gift')) cur.setAttribute(a.name, a.value); setTimeout(syncGift, 0); }
    const n = fresh?.querySelector('[data-fe-cart-count]')?.textContent;
    if (n != null) $$('[data-fe-cart-count]').forEach((el) => (el.textContent = n));
  };
  // Regalo por compra: agrega o quita la línea del regalo (propiedad _regalo) según lo que calcula el carrito.
  let giftBusy = false;
  async function syncGift() {
    const c = document.getElementById('fe-cart'); if (!c || giftBusy) return;
    const should = c.dataset.giftShould === '1', any = c.dataset.giftAny === '1', key = c.dataset.giftKey, v = +c.dataset.giftVariant;
    let body = null, url = null;
    if (should && !any && v) { url = '/cart/add.js'; body = { items: [{ id: v, quantity: 1, properties: { _regalo: c.dataset.giftName || 'Regalo' } }], sections: SECTION }; }
    else if (!should && key) { url = '/cart/change.js'; body = { id: key, quantity: 0, sections: SECTION }; }
    if (!url) return;
    giftBusy = true;
    try {
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-FE': '1' }, body: JSON.stringify(body) });
      const j = await r.json(); giftBusy = false;
      if (r.ok && j.sections?.[SECTION]) applyCart(j.sections[SECTION]);
    } catch (e) { giftBusy = false; }
  }
  FE.syncGift = syncGift;
  FE.refreshCart = async () => {
    try { const r = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=${SECTION}`); const j = await r.json(); if (j[SECTION]) applyCart(j[SECTION]); } catch (err) { /* el carrito se ve igual que antes */ }
  };
  const busy = (on) => document.getElementById('fe-cart')?.classList.toggle('is-loading', on);
  FE.add = async (items) => {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-FE': '1' }, body: JSON.stringify({ items, sections: SECTION }) });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar');
    if (j.sections?.[SECTION]) applyCart(j.sections[SECTION]); else await FE.refreshCart();
    FE.open('fe-cart');
    return j;
  };
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-fe-add]');
    if (a) { e.preventDefault(); busy(true); try { await FE.add([{ id: +a.dataset.feAdd, quantity: 1 }]); } finally { busy(false); } return; }
    const q = e.target.closest('[data-fe-qty]');
    if (q) {
      e.preventDefault(); busy(true);
      try {
        const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-FE': '1' }, body: JSON.stringify({ id: q.dataset.feQty, quantity: Math.max(0, +q.dataset.q), sections: SECTION }) });
        const j = await r.json(); if (j.sections?.[SECTION]) applyCart(j.sections[SECTION]); else await FE.refreshCart();
      } finally { busy(false); }
    }
  });
  // Otras piezas (apps como «Completa tu look») que agregan al carrito por su cuenta: abrir el carrito propio.
  const isAdd = (u) => /\/cart\/add(\.js)?(\?|$)/.test(String(u || ''));
  const onForeignAdd = () => { FE.refreshCart().then(() => FE.open('fe-cart')); };
  const _fetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input?.url;
    const mine = init?.headers && (init.headers['X-FE'] || (init.headers.get && init.headers.get('X-FE')));
    const p = _fetch.apply(this, arguments);
    if (isAdd(url) && !mine) p.then((r) => { if (r.ok) onForeignAdd(); }).catch(() => {});
    return p;
  };
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { this._feAdd = isAdd(u); return _open.apply(this, arguments); };
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () { if (this._feAdd) this.addEventListener('load', () => { if (this.status < 400) onForeignAdd(); }); return _send.apply(this, arguments); };

  setTimeout(syncGift, 800);

  // ---------- carruseles: flechas ----------
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-fe-car]'); if (!b) return;
    const t = b.closest('section, .fe-sec')?.querySelector('[data-fe-track]'); if (!t) return;
    t.scrollBy({ left: t.clientWidth * 0.8 * +b.dataset.feCar, behavior: 'smooth' });
  });

  // ---------- ficha de producto ----------
  $$('[data-fe-pdp]').forEach((root) => {
    const data = JSON.parse(root.querySelector('[data-fe-pdp-json]').textContent);
    const sel = {};
    $$('[data-fe-opt].is-on', root).forEach((b) => (sel[b.dataset.feOpt] = b.dataset.val));
    const idInput = $('[data-fe-variant-id]', root), atc = $('[data-fe-atc]', root), price = $('[data-fe-price]', root), msg = $('[data-fe-msg]', root);
    const gal = $('[data-fe-gal]', root), galN = $('[data-fe-galn]', root);
    const find = () => data.variants.find((v) => v.options.every((o, i) => o === sel[i]));
    const render = () => {
      const v = find();
      $$('[data-fe-opt]', root).forEach((b) => {
        const i = +b.dataset.feOpt;
        const ok = data.variants.some((x) => x.available && x.options[i] === b.dataset.val && x.options.every((o, j) => j === i || o === sel[j]));
        b.classList.toggle('is-out', !ok);
      });
      $$('[data-fe-sel]', root).forEach((s) => (s.textContent = sel[+s.dataset.feSel] || ''));
      if (!v) { atc.disabled = true; atc.textContent = 'No disponible'; return; }
      idInput.value = v.id;
      atc.disabled = !v.available; atc.textContent = v.available ? atc.dataset.label : 'Agotado';
      price.innerHTML = v.compare_at_price > v.price ? `<span class="fe-price--sale">${FE.money(v.price)}</span> <s>${FE.money(v.compare_at_price)}</s>` : FE.money(v.price);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      if (v.featured_media && gal) {
        const idx = $$('.fe-gal__it', gal).findIndex((el) => el.dataset.mediaId == v.featured_media.id);
        if (idx >= 0 && gal.scrollWidth > gal.clientWidth) gal.scrollTo({ left: idx * gal.clientWidth, behavior: 'smooth' });
      }
    };
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-fe-opt]'); if (!b) return;
      $$(`[data-fe-opt="${b.dataset.feOpt}"]`, root).forEach((x) => x.classList.toggle('is-on', x === b));
      sel[b.dataset.feOpt] = b.dataset.val; render();
    });
    const qty = $('[data-fe-qty-input]', root);
    $$('[data-fe-step]', root).forEach((b) => b.addEventListener('click', () => { qty.value = Math.max(1, (+qty.value || 1) + +b.dataset.feStep); }));
    atc?.addEventListener('click', async (e) => {
      e.preventDefault(); if (atc.disabled) return;
      msg.textContent = ''; atc.disabled = true;
      try { await FE.add([{ id: +idInput.value, quantity: Math.max(1, +qty.value || 1) }]); }
      catch (err) { msg.textContent = err.message; }
      finally { atc.disabled = false; render(); }
    });
    $('[data-fe-form]', root)?.addEventListener('submit', (e) => { e.preventDefault(); atc?.click(); });
    if (gal && galN) gal.addEventListener('scroll', () => { const i = Math.round(gal.scrollLeft / gal.clientWidth); galN.textContent = `${i + 1} / ${gal.children.length}`; }, { passive: true });
    render();
  });

  // ---------- escalonado de Navidad en la ficha ----------
  $$('[data-fe-escala]').forEach((esc) => {
    const ids = esc.dataset.ids.split(',').map(Number);
    const qty = $('[data-fe-qty-input]'), note = $('[data-fe-esc-note]', esc), base = note?.innerHTML;
    const rows = $$('[data-fe-esc-tier]', esc);
    let inCart = 0;
    const paint = () => {
      const q = Math.max(1, +qty?.value || 1), n = inCart + q;
      rows.forEach((r) => r.classList.toggle('is-on', +r.dataset.feEscTier === Math.min(q, 3)));
      const total = rows[Math.min(n, 3) - 1]?.dataset.price;
      if (note) note.innerHTML = inCart > 0 ? `Ya llevas ${inCart} en tu carrito: con ${q === 1 ? 'esta' : 'estas'} serían ${n}, a ${total}${n > 1 ? ' c/u' : ''}. ${base}` : base;
    };
    const load = async () => {
      try { const c = await (await fetch('/cart.js')).json(); inCart = c.items.filter((i) => ids.includes(i.product_id)).reduce((s, i) => s + i.quantity, 0); } catch (e) { /* sin carrito, cuenta solo la cantidad */ }
      paint();
    };
    rows.forEach((r) => r.addEventListener('click', () => { if (qty) qty.value = +r.dataset.feEscTier; paint(); }));
    qty?.addEventListener('input', paint);
    $$('[data-fe-step]').forEach((b) => b.addEventListener('click', () => setTimeout(paint)));
    $('[data-fe-atc]')?.addEventListener('click', () => setTimeout(load, 1500));
    load();
  });

  // ---------- portada con miniaturas ----------
  $$('[data-fe-hero]').forEach((hero) => {
    const slides = $$('.fe-hero__slide', hero), thumbs = $$('.fe-hero__thumb', hero), stage = $('.fe-hero__stage', hero);
    if (!slides.length) return;
    const mq = matchMedia('(max-width: 767px)');
    let i = 0, timer = null, visible = true;
    const ar = () => { const s = slides[i]; stage.style.setProperty('--fe-hero-ar', mq.matches ? s.style.getPropertyValue('--ar-m') : s.style.getPropertyValue('--ar-d')); };
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { const on = k === i; s.classList.toggle('is-on', on); s.toggleAttribute('aria-hidden', !on); s.tabIndex = on ? 0 : -1; if (on) s.querySelectorAll('img[loading=lazy]').forEach((im) => (im.loading = 'eager')); });
      thumbs.forEach((t, k) => { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i); });
      ar();
    };
    const speed = (+hero.dataset.speed || 0) * 1000;
    const start = () => { clearInterval(timer); if (speed && slides.length > 1) timer = setInterval(() => { if (visible && !document.hidden) go(i + 1); }, speed); };
    thumbs.forEach((t) => t.addEventListener('click', () => { go(+t.dataset.feHeroGo); start(); t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }));
    hero.addEventListener('mouseenter', () => clearInterval(timer)); hero.addEventListener('mouseleave', start);
    new IntersectionObserver((es) => { visible = es[0].isIntersecting; }).observe(hero);
    mq.addEventListener('change', ar);
    ar(); start();
    // precargar el siguiente cuando el navegador esté libre
    (window.requestIdleCallback || setTimeout)(() => slides.slice(1).forEach((s) => s.querySelectorAll('img[loading=lazy]').forEach((im) => (im.loading = 'eager'))), 2500);
  });

  // ---------- tiendas del home: carrusel por tienda ----------
  $$('[data-fe-stt]').forEach((root) => {
    const imgs = $$('.fe-stt__img', root), infos = $$('.fe-stt__info', root), tabs = $$('[data-fe-stt-go]', root);
    if (imgs.length < 2) return;
    let i = 0, timer = null, visible = true;
    const go = (n) => {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach((x, k) => x.classList.toggle('is-on', k === i));
      infos.forEach((x, k) => x.classList.toggle('is-on', k === i));
      tabs.forEach((t, k) => { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i); });
      imgs[i].querySelectorAll('img[loading=lazy]').forEach((im) => (im.loading = 'eager'));
    };
    const speed = (+root.dataset.speed || 0) * 1000;
    if (speed) timer = setInterval(() => { if (visible && !document.hidden) go(i + 1); }, speed);
    const stop = () => { clearInterval(timer); timer = null; };   // al elegir una tienda, deja de rotar
    tabs.forEach((t) => t.addEventListener('click', () => { stop(); go(+t.dataset.feSttGo); }));
    $$('[data-fe-stt-step]', root).forEach((b) => b.addEventListener('click', () => { stop(); go(i + +b.dataset.feSttStep); }));
    new IntersectionObserver((es) => { visible = es[0].isIntersecting; if (visible) imgs.forEach((x) => x.querySelectorAll('img[loading=lazy]').forEach((im) => (im.loading = 'eager'))); }, { rootMargin: '200px' }).observe(root);
  });

  // ---------- tiendas: carrusel de fotos con puntos ----------
  $$('[data-fe-store-car]').forEach((car) => {
    const tr = $('[data-fe-store-track]', car), dots = $$('[data-fe-store-dot]', car);
    if (!dots.length) return;
    dots.forEach((d) => d.addEventListener('click', () => tr.scrollTo({ left: +d.dataset.feStoreDot * tr.clientWidth, behavior: 'smooth' })));
    tr.addEventListener('scroll', () => { const k = Math.round(tr.scrollLeft / tr.clientWidth); dots.forEach((d, j) => d.classList.toggle('is-on', j === k)); }, { passive: true });
  });

  // ---------- recomendaciones de la ficha ----------
  $$('[data-fe-recs]').forEach(async (el) => {
    try {
      const r = await fetch(`${el.dataset.url}&section_id=${el.dataset.section}`);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const fresh = doc.querySelector('[data-fe-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML; else el.closest('.fe-sec')?.remove();
    } catch (e) { el.closest('.fe-sec')?.remove(); }
  });

  // ---------- colección: filtros y orden ----------
  $$('[data-fe-col]').forEach((root) => {
    const main = $('.fe-col-main', root), form = $('[data-fe-filters-form]', root);
    const mq = matchMedia('(max-width: 767px)');
    $$('[data-fe-filt]', root).forEach((b) => b.addEventListener('click', () => {
      const open = !main.classList.contains('f-open');
      main.classList.toggle('f-open', open);
      if (mq.matches) { main.classList.toggle('f-open-m', open); document.body.classList.toggle('fe-has-drawer', open); }
      try { sessionStorage.setItem('fe-filt-open', open && !mq.matches ? '1' : '0'); } catch {}
    }));
    try { if (!mq.matches && sessionStorage.getItem('fe-filt-open') === '1') main.classList.add('f-open'); } catch {}
    const submit = () => {
      const fd = new FormData(form); const sort = $('[data-fe-sort]', root)?.value;
      const params = new URLSearchParams();
      for (const [k, v] of fd) if (v !== '') params.append(k, v);
      if (sort) params.set('sort_by', sort);
      location.search = params.toString();
    };
    form?.addEventListener('change', (e) => { if (e.target.matches('input[type=checkbox]')) submit(); });
    form?.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
    $('[data-fe-sort]', root)?.addEventListener('change', submit);
  });
})();
